package dev.bitspittle.droidconSf24.pages.sections.kobweb.fullstack

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun BuildScriptPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/fullstack/BuildScript.md", mapOf("follows" to listOf("FullstackVsStatic")))) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            dev.bitspittle.droidconSf24.components.widgets.Code("""// build.gradle.kts
kotlin {
    configAsKobwebApplication(
        "app",
        includeServer = true
    )

    sourceSets {
        jsMain.dependencies { /* ... */ }
        jvmMain.dependencies {
            compileOnly(libs.kobweb.api)
            /* ... */
        }
    }
}
""", "kotlin 0|5,10-13 <hide-vertical-scrollbar>")
        }
    }
}
